
import { defineComponent, ref, computed, watch, Ref, reactive, toRefs, onMounted, onUnmounted,nextTick } from "vue";
import {  getUpdate, getChangePass,receivelist } from '@/service/main/dashboard'
import { useStore } from "@/store";
import { RouteLocationMatched, useRoute, useRouter } from "vue-router";
import BreadCrumb from "@/common-ui/breadcrumb";
import NavDialog from "./cpn/NavDialog.vue";
import cache from '@/utils/cache'
import { breadCrumbMapToMenu } from "@/utils/menuToRoute";
import localCache from "@/utils/cache";
import { ElMessage, ElMessageBox } from "element-plus";
import message from './message/message.vue'
export default defineComponent({
  emits: ["changeMenuFold"],
  name: "NavHeader",
  components: {
    BreadCrumb,
    NavDialog,
    message
  },
  setup(props, { emit }) {
    const isFold = ref(true);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userInfo = computed(() => store.state.login.userInfo);
    //面包屑数据
    const breadCrumbInfo: Ref<RouteLocationMatched[]> = ref([])

    const getCrumbInfo = () => {
      //过滤路由
      let matched = route.matched.filter(menu => menu.meta && menu.meta.title);
      const first = matched[0];
      if (first?.path !== '/') {
        matched = [{ path: '/', meta: { title: '首页' } } as any].concat(matched);
      }
      breadCrumbInfo.value = matched;
    }
    getCrumbInfo();
    //监视当前路由地址
    watch(() => route.path, () => {
      getCrumbInfo();
    })
    const menuFoldAction = () => {
      emit("changeMenuFold", isFold.value);
      isFold.value = !isFold.value;
    };
    // github图标
    const gotoGithub = () => {
      window.location.href = "https://github.com/fuzhibin/vue3_ts_cms";
    };
    // qq/weichat/公告 图标
    const navDialogRef = ref<InstanceType<typeof NavDialog>>();
    const showDialogClic = (flag: string) => {
      navDialogRef.value!.isShow = true;
      if (flag === "qq") {
        navDialogRef.value!.showFlag = 1;
      } else if (flag === "weichat") {
        navDialogRef.value!.showFlag = 2;
      } else if (flag === "gonggao") {
        navDialogRef.value!.showFlag = 3;
      } else if (flag === "runtime") {
        navDialogRef.value!.showFlag = 4;
      }
    };
    
    // 消息变更数据
    const MessageList: any = ref([])
    // 消息变更数据条数
    const mesCount = ref(0)
    // 消息变更的身份
    const identity = ref(0)
    const dialogRef = ref()
    //密码校验
    const validatePass = (rule: any, value: any, callback: any) => {
      const reg = /^\w{6,16}$/;
      if (!reg.test(value)) {
        callback(new Error("密码必须为6-16位非汉字字符"));
      }
      callback();
    };

    //确认密码
    const validateConfirm = (rule: any, value: any, callback: any) => {
      if (value.length < 6 || value.length > 16) {
        callback(new Error("密码必须为6-16位非汉字字符"));
      } else {
        if (value != changeForm.newPassword) {
          callback(new Error("两次密码输入不一致"));
        } else {
          callback();
        }
      }
    };

    //rules
    const formRules = {
      password: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
      newPassword: [{ required: true, message: '新密码不能为空', trigger: 'blur' }, { validator: validatePass, trigger: "blur" }],
      confirmPassword: [{ required: true, message: '确认密码不能为空', trigger: 'blur' },{ validator: validateConfirm, trigger: "blur" }]
    }
    // 修改密码窗口默认关闭状态
    const dialogVisible = ref(false)
    // 表单数据绑定
    const changeForm = reactive({
      id: 0,
      password: "",
      newPassword: "",
      confirmPassword:""
    })
    //修改密码
    const changePassword = () => {
      dialogVisible.value = true
      changeForm.id = localCache.getCache('changePasswordId')
    }
    // 修改密码窗口关闭时的Close事件
    const closeDialog = () => {
      // console.log("关闭了")
    }
    // 修改密码确定按钮
    const corfirm = () => {
      dialogRef.value.validate((vali: any) => {
        if (vali) {
          getChangePass(changeForm).then((res: any) => {

            dialogVisible.value = false
            ElMessage.success("修改成功5秒后将退出系统")
            setTimeout(() => {
              localCache.deleteCache("token");
              store.commit('login/changeUserInfo', {})
              router.replace("/login");
              cache.deleteCache('editableTabs');
              cache.deleteCache('editableTabsValue')
            }, 5000)

          }).catch((err) => {
            console.log()
          })

        }
      })
    }
    // 退出登陆
    const exitLoginClic = () => {
      localCache.deleteCache("token");
      store.commit('login/changeUserInfo', {})
      router.replace("/login");
      cache.deleteCache('editableTabs');
      cache.deleteCache('editableTabsValue');
      localCache.deleteCache("captchaCode"); 
    };
    const dropdown = ref()
    onMounted(()=>{
      nextTick(()=>{
        dropdown.value.updatePopper();
      })
    })   
    const handleClick = () => {
    // ElMessage(`click on item ${command}`)
    nextTick(()=>{
        dropdown.value.updatePopper();
      })
    } 
    // username
    const userName = computed(() => store.state.login.name)
    return {
      userInfo,
      exitLoginClic,
      showDialogClic,
      menuFoldAction,
      isFold,
      breadCrumbInfo,
      gotoGithub,
      navDialogRef,
      userName,
      
      mesCount,
      
      MessageList,
      
      identity,
      
      changePassword,
      dialogVisible,
      closeDialog,
      changeForm,
      corfirm,
      formRules,
      dialogRef
    };
  }
});
